import { render, staticRenderFns } from "./ViewPif.vue?vue&type=template&id=64612b64&"
import script from "./ViewPif.vue?vue&type=script&lang=js&"
export * from "./ViewPif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports